import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import ContactBlock from "./ContactBlock";
import Grid from "./Grid";
import HeadingLarge from "./HeadingLarge";
import HeadingSmall from "./HeadingSmall";
import Layout from "./Layout";
import PageContent from "./PageContent";
import React from "react";

function ContactPage({ pageData, navItems, globalData }) {
  return (
    <Layout navItems={navItems} globalData={globalData}>
      <PageContent>
        <BoxWithGutter bg="peach" py={[100, null, 120, null]}>
          <HeadingLarge uppercase>{pageData.heading}</HeadingLarge>
          <Box mt={[30, null, 45, null]} mb={[60, null, 80, null]}>
            <HeadingSmall as="p">{pageData.subheading}</HeadingSmall>
          </Box>
          <Grid desktopCols={2} mobCols={1}>
            {pageData.contacts.map((contact, index) => {
              return <ContactBlock key={index} {...contact.value} />;
            })}
          </Grid>
        </BoxWithGutter>
      </PageContent>
    </Layout>
  );
}

export default ContactPage;
